import getLocalWishlist from '../utils/getLocalWishlist';
import getProductGidByHandle from '../utils/requests/getProductGidFromHandle';
import updateRemoteWishlist from '../utils/requests/updateRemoteWishlist';
import CONSTANTS from '../utils/vars/CONSTANTS';

if (!customElements.get('wishlist-button')) {
  class WishlistButton extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.updateWishlistState(false);
      this.initializeEventListeners();
    }

    get button() {
      return this.querySelector('button');
    }

    get productHandle() {
      return this.button?.dataset.productHandle;
    }

    get localWishlist() {
      return getLocalWishlist();
    }

    initializeEventListeners() {
      if (!this.button) return;

      this.button.disabled = false;
      if (!this.listenersAttached) {
        this.button.addEventListener('click', this.handleWishlistToggle.bind(this));
        this.listenersAttached = true;
      }
    }

    handleWishlistToggle() {
      this.updateWishlistState();
    }

    async updateWishlistState(shouldChangeState = true) {
      const wishlist = this.localWishlist;
      const productIndex = wishlist.indexOf(this.productHandle);
      let isActive = productIndex !== -1;

      if (shouldChangeState) {
        if (isActive) {
          wishlist.splice(productIndex, 1);
        } else {
          wishlist.push(this.productHandle);
        }
        isActive = !isActive; // Toggle the state
        this.saveWishlistToLocalStorage(wishlist);
        this.updateButtonAppearance(isActive);

        await this.syncRemoteWishlist();
      } else {
        this.updateButtonAppearance(isActive);
      }
    }

    saveWishlistToLocalStorage(wishlist) {
      const wishlistString = wishlist.join(CONSTANTS.LOCAL_STORAGE_DELIMITER);
      localStorage.setItem(CONSTANTS.LOCAL_STORAGE_WISHLIST_KEY, wishlistString);
    }

    async syncRemoteWishlist() {
      if (CONSTANTS.CUSTOMER_LOGGED_IN) {
        const productGid = await getProductGidByHandle(this.productHandle);
        if (productGid) await updateRemoteWishlist(productGid);
      }
      document.dispatchEvent(new CustomEvent('wishlist:updated'));
    }

    updateButtonAppearance(isActive) {
      if (isActive) {
        this.classList.add(CONSTANTS.BUTTON_ACTIVE_CLASS);
      } else {
        this.classList.remove(CONSTANTS.BUTTON_ACTIVE_CLASS);
      }
    }
  }

  customElements.define('wishlist-button', WishlistButton);
}
